import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import {
  authRoutes,
  protectedRoutes,
  protectedRoutesWithBlankLayout,
} from "./index";

import ProtectedLayout from "../layouts/ProtectedLayout";
import ProtectedBlankLayout from "../layouts/ProtectedBlankLayout";
import AuthLayout from "../layouts/AuthLayout";
import Page404 from "../pages/auth/Page404";

const childRoutes = (Layout, routes) =>
  routes.map(({ component: Component, guard, children, path }, index) => {
    const Guard = guard || React.Fragment;

    return children ? (
      children.map((element, index) => {
        const Guard = element.guard || React.Fragment;
        const ElementComponent = element.component || React.Fragment;

        return (
          <Route
            key={index}
            path={element.path}
            exact
            render={(props) => (
              <Layout>
                <Guard>
                  <ElementComponent {...props} />
                </Guard>
              </Layout>
            )}
          />
        );
      })
    ) : Component ? (
      <Route
        key={index}
        path={path}
        exact
        render={(props) => (
          <Layout>
            <Guard>
              <Component {...props} />
            </Guard>
          </Layout>
        )}
      />
    ) : null;
  });

const Routes = () => (
  <Router>
    <Switch>
      {childRoutes(ProtectedLayout, protectedRoutes)}
      {childRoutes(ProtectedBlankLayout, protectedRoutesWithBlankLayout)}
      {childRoutes(AuthLayout, authRoutes)}
      <Route
        render={() => (
          <AuthLayout>
            <Page404 />
          </AuthLayout>
        )}
      />
    </Switch>
  </Router>
);

export default Routes;
